import React from 'react';

const Movements = ({ data }) => {
  return (
    <div className="p-4 md:p-6">
      <h1 className="text-2xl font-semibold">Em construção</h1>
    </div>
  );
};

export default Movements;
